import DanceList from 'components/Dance/DanceList'
import {Loading, Page, PageContent} from 'components/Page'
import {React, styled} from 'common'
import useMyDances from 'logic/Main/useMyDances.js'

const MyDances = () => {
    const {myDances, isLoading, t} = useMyDances()
    return (
        <Page title={t('title')}>
            {isLoading ? (
                <Loading loadingText={t('loading')} isLoading={isLoading} />
            ) : (
                <StyledPageContent>
                    <DanceList
                        dances={myDances || []}
                        height={480}
                        isMyDances
                    />
                </StyledPageContent>
            )}
        </Page>
    )
}

export default MyDances

const StyledPageContent = styled(PageContent)`
    min-height: 100vh;
`
